/* Liste d'envies maison, sans application : la liste vit dans le navigateur du
   visiteur (localStorage), le compteur s'affiche dans l'en-tête, et la page
   /pages/ma-liste-d-envies rend les pièces retenues en interrogeant Shopify.
   Même grammaire visuelle que le reste du site : un cœur fin, pas de couleur. */
(() => {
  const CLE = 'rl_envies';

  const lire = () => {
    try { return JSON.parse(localStorage.getItem(CLE)) || []; } catch (e) { return []; }
  };
  const ecrire = (liste) => {
    try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) {}
    compteur();
  };
  const dedans = (h) => lire().indexOf(h) !== -1;
  const basculer = (h) => {
    const l = lire();
    const i = l.indexOf(h);
    if (i === -1) l.push(h); else l.splice(i, 1);
    ecrire(l);
    return i === -1;
  };

  const compteur = () => {
    const n = lire().length;
    const val = n ? String(n) : '';
    document.querySelectorAll('.rl-envies__nb').forEach((e) => {
      // on n'ecrit que si la valeur change : sinon l'observateur se rappelle lui-meme
      if (e.textContent !== val) e.textContent = val;
      if (e.hidden !== !n) e.hidden = !n;
    });
    document.querySelectorAll('.rl-coeur').forEach((b) => {
      b.classList.toggle('rl-coeur--pris', dedans(b.dataset.handle));
      b.setAttribute('aria-pressed', dedans(b.dataset.handle) ? 'true' : 'false');
    });
  };

  const COEUR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M12 20.2s-7.3-4.4-7.3-9.4a4.2 4.2 0 0 1 7.3-2.8 4.2 4.2 0 0 1 7.3 2.8c0 5-7.3 9.4-7.3 9.4z"/></svg>';

  const bouton = (handle, classe) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'rl-coeur ' + (classe || '');
    b.dataset.handle = handle;
    b.setAttribute('aria-label', "Ajouter à ma liste d'envies");
    b.innerHTML = COEUR;
    b.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      basculer(handle);
    });
    return b;
  };

  const handleDe = (lien) => {
    const m = (lien.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  };

  /* un cœur sur chaque vignette de la grille */
  const poserCartes = () => {
    document.querySelectorAll('.card-wrapper, .card__inner').forEach((c) => {
      if (c.querySelector(':scope > .rl-coeur') || c.dataset.rlCoeur) return;
      const lien = c.querySelector('a[href*="/products/"]');
      if (!lien) return;
      const h = handleDe(lien);
      if (!h) return;
      const cible = c.querySelector('.card__inner') || c;
      if (cible.querySelector('.rl-coeur')) return;
      cible.dataset.rlCoeur = '1';
      cible.style.position = cible.style.position || 'relative';
      cible.appendChild(bouton(h, 'rl-coeur--carte'));
    });
  };

  /* un cœur dans la buy-box de la fiche produit */
  const poserFiche = () => {
    const forme = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!forme || forme.dataset.rlCoeur) return;
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    forme.dataset.rlCoeur = '1';
    const l = document.createElement('div');
    l.className = 'rl-envies-ligne';
    const b = bouton(m[1], 'rl-coeur--fiche');
    const t = document.createElement('span');
    t.textContent = "Ajouter à ma liste d'envies";
    l.appendChild(b);
    l.appendChild(t);
    t.addEventListener('click', () => b.click());
    forme.parentElement.insertBefore(l, forme.nextSibling);
  };

  /* la page liste : on redemande chaque pièce à Shopify, rien n'est stocké chez nous */
  const rendreListe = async () => {
    const zone = document.getElementById('rl-envies-liste');
    if (!zone) return;
    const liste = lire();
    if (!liste.length) {
      zone.innerHTML = '<p class="rl-envies-vide">Votre liste est vide pour l\'instant. ' +
        'Le cœur, sur une vignette ou sur une fiche, met une pièce de côté.</p>' +
        '<p class="rl-envies-vide"><a class="link-with-icon" href="/collections/nouveautes">Voir les nouveautés</a></p>';
      return;
    }
    const cartes = [];
    for (const h of liste) {
      try {
        const p = await (await fetch(`/products/${h}.js`)).json();
        const prix = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
        const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        cartes.push(`<article class="rl-envies-carte">
            <a href="/products/${p.handle}" class="rl-envies-carte__img">${img ? `<img src="${img}" alt="${p.title}" loading="lazy">` : ''}</a>
            <a href="/products/${p.handle}" class="rl-envies-carte__titre">${p.title}</a>
            <p class="rl-envies-carte__prix">${prix}</p>
            <button type="button" class="rl-envies-carte__retirer" data-handle="${p.handle}">Retirer</button>
          </article>`);
      } catch (e) {}
    }
    zone.innerHTML = `<div class="rl-envies-grille">${cartes.join('')}</div>`;
    zone.querySelectorAll('.rl-envies-carte__retirer').forEach((b) => {
      b.addEventListener('click', () => {
        basculer(b.dataset.handle);
        rendreListe();
      });
    });
  };

  const demarrer = () => {
    poserCartes();
    poserFiche();
    compteur();
    rendreListe();
    // la grille arrive parfois apres coup (filtres, pagination) : on repasse,
    // mais en differe et sans observer nos propres ajouts, sinon la page tourne en boucle
    let attente = null;
    const obs = new MutationObserver(() => {
      if (attente) return;
      attente = setTimeout(() => {
        attente = null;
        obs.disconnect();
        poserCartes();
        compteur();
        obs.observe(document.body, { childList: true, subtree: true });
      }, 250);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState !== 'loading') demarrer();
  else document.addEventListener('DOMContentLoaded', demarrer);
})();
